module.exports = __webpack_public_path__ + "static/securedapp-section-img-1f7a9e06ac78b39b5f12c28508a5290a.png";